import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const REACTIONS = ["👍", "❤️", "🔥", "💪", "😅"];

export const Reactions = ({ message, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const current = message.reaction?.emoji || null;
  const react = async (e) => {
    setBusy(true);
    try { const r = await api.post(`/client/me/messages/${message.id}/react`, { emoji: e === current ? null : e }); onChanged?.(r.data); }
    catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <div className="reactions" data-testid={`reactions-${message.id}`}>
      {REACTIONS.map((e) => (
        <button key={e} type="button" className={current === e ? "on" : ""} disabled={busy} onClick={() => react(e)} aria-label={`React ${e}`} aria-pressed={current === e} data-testid={`react-${message.id}-${REACTIONS.indexOf(e)}`}>{e}</button>
      ))}
      {current && <span className="ss" data-testid={`reaction-current-${message.id}`}>You reacted {current}{message.reactionBack ? ` · Coach sent ${message.reactionBack.emoji} back` : ""}</span>}
    </div>
  );
};

export const COACH_REACTIONS = ["👍", "❤️", "🙌", "😄", "💯"];

export const ReactionBadge = ({ message, testId, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const [back, setBack] = useState(message?.reactionBack || null);
  if (!message?.reaction?.emoji) return null;
  const tid = testId || `reaction-badge-${message.id}`;
  const send = async (e) => {
    setBusy(true);
    try { const r = await api.post(`/messages/${message.id}/react-back`, { emoji: e }); setBack(r.data.reactionBack); toast.success(`Sent ${e} back to the client`); onChanged?.(r.data); }
    catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <div className="reactions" style={{ marginTop: 4 }} data-testid={tid}>
      <span className="chip gray" title="Client reaction">{message.reaction.emoji} reacted</span>
      {back ? <span className="ss" data-testid={`${tid}-back`}>you sent {back.emoji} back</span>
        : <>{COACH_REACTIONS.map((e, i) => <button key={e} type="button" disabled={busy} onClick={() => send(e)} aria-label={`React back ${e}`} data-testid={`${tid}-back-${i}`}>{e}</button>)}</>}
    </div>
  );
};
